/**
 * External PromoTix checkout URLs for Discovery (primary events).
 */
export const appendReferrerDiscovery = url => {
  if (!url || typeof url !== 'string') {
    return null;
  }
  return url.includes('?') ? `${url}&referrer=discovery` : `${url}?referrer=discovery`;
};
